import { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

export const useIsMergedLotteryPage = (lotteryId: unknown) =>
  useIsFeatureFlagEnabled('mergedLotteryPage') &&
  getLotteryIdInCorrectCase(lotteryId) !== LotteryId.NebraskaMyDay
